import { get, post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";

export const getProgressReport = (projectId: string, drawId: string) =>
  get(ENDPOINTS.CONSTRUCTION_REPORT.PROGRESS_REPORT(projectId, drawId));

export const publishProgressReport = (
  projectId: string,
  drawId: string,
  payload: Record<string, unknown>,
  publish: boolean,
) =>
  post(
    ENDPOINTS.CONSTRUCTION_REPORT.PUBLISH_REPORT(projectId, drawId, publish),
    payload,
  );
